import "@reach/combobox/styles.css";

import {
  Combobox,
  ComboboxInput,
  ComboboxList,
  ComboboxOption,
  ComboboxOptionText,
  ComboboxPopover,
} from "@reach/combobox";
import React, { useEffect, useRef, useState } from "react";

import ReactDOM from "react-dom";
import { redirect_post } from "../modules/QuickAddCart";
import { showQuickAddModal } from "../modules/QuickAddCart";

const cache = {};

function useSearch(searchTerm) {
  const [searchResult, setSearchResult] = useState([]);
  useEffect(() => {
    if (searchTerm.trim() !== "") {
      let isFresh = true;
      fetchProducts(searchTerm).then((result) => {
        if (isFresh) setSearchResult(result);
      });
      return () => (isFresh = false);
    }
  }, [searchTerm]);
  return searchResult;
}

function fetchProducts(value) {
  if (cache[value]) {
    return Promise.resolve(cache[value]);
  }
  return fetch("/esearch?q=" + value)
    .then((res) => res.json())
    .then((result) => {
      cache[value] = result;
      return result;
    });
}

function redirectTo(value) {
  fetchProducts(value).then((result) => {
    let products = result.products;
    let productIds = products.map((p) => p.id);
    let id = productIds.join();
    redirect_post("/search", [id], value);
  });
}

function Search() {
  const popoverRef = useRef(null);
  const inputRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { products } = useSearch(searchTerm);

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRedirectSearchTermChange = (event) => {
    if (event.key === "Enter") {
      let value = event.target.value;
      redirectTo(value);
    }
  };

  const handleRedirectSearchTermChangeOnClick = (event) => {
    let value = document.getElementById("searchfield");
  console.log("value");console.log(value.value);
    if (value) {
      redirectTo(value.value);
    }
  };

  return (
    <Combobox
      aria-label="Produits"
      className="ElasticSearch"
      onSelect={(product) => {
        if (inputRef.current) {
          inputRef.current.blur();
        }
        showQuickAddModal(`/?view=ajax/modal-product&product_id=${product.id}&stock=${product.stock}`);
      }}
    >
      <div
        style={{
          position: "relative",
        }}
      >
        <ComboboxInput
          ref={inputRef}
          id="searchfield"
          autocomplete={false}
          onChange={handleSearchTermChange}
          onKeyPress={handleRedirectSearchTermChange}
          className="form-control ElasticSearch-input"
          value={searchTerm.title || searchTerm}
          placeholder="Votre recherche..."
          onKeyDown={(event) => {
            if (!event.isDefaultPrevented()) {
              const container = popoverRef.current;
              if (!container) return;

              window.requestAnimationFrame(() => {
                const element = container.querySelector("[aria-selected=true]");
                if (element) {
                  const top = element.offsetTop - container.scrollTop;
                  const bottom =
                    container.scrollTop +
                    container.clientHeight -
                    (element.offsetTop + element.clientHeight);

                  if (bottom < 0) container.scrollTop -= bottom;
                  if (top < 0) container.scrollTop += top;
                }
              });
            }
          }}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 490 490"
          className="text-primary"
          onClick={handleRedirectSearchTermChangeOnClick}
          style={{
            position: "absolute",
            top: "50%",
            right: 20,
            width: 20,
            height: "100%",
            transform: "translateY(-50%)",
            stroke: "currentcolor",
          }}
        >
          <path
            fill="none"
            strokeWidth="36"
            strokeLinecap="round"
            d="M280 278a153 153 0 10-2 2l170 170m-91-117l110 110-26 26-110-110"
          />
        </svg>
      </div>
      {products && (
        <ComboboxPopover className="ElasticSearch-popover" ref={popoverRef}>
          {products.length > 0 ? (
            <ComboboxList>
              {products.map((product) => {
                return (
                  <ComboboxOption key={product.id} value={product}>
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          product.image
                            ? product.image
                            : "//placehold.it/200x200"
                        }
                        className="ElasticSearch-product-img"
                        alt=""
                      />
                      <div>{product.title}</div>
                    </div>
                  </ComboboxOption>
                );
              })}
            </ComboboxList>
          ) : (
            <span style={{ display: "block", margin: 8 }}>Aucun résultat</span>
          )}
        </ComboboxPopover>
      )}
    </Combobox>
  );
}

export default function ElasticSearch() {
  const root = document.querySelector("#Header-search");
  if (!root) return;
  ReactDOM.render(<Search />, root);
}



// WEBPACK FOOTER //
// ./assets/src/js/modules/ElasticSearch.js